export const replaceAddress = (str, companyAddress) => {
  const searchStr = /companyAddress/gi;
  const newStr = str.replace(searchStr, companyAddress);
  return newStr;
};
